export default "__VITE_ASSET__DSMnzUhp__"